import React, { type JSX, ReactNode } from 'react';

import { Box } from '@rover/kibble/core';

export type Props = {
  children: ReactNode;
};

const MessageBubble = ({ children }: Props): JSX.Element => {
  return (
    <Box background="secondary" borderRadius="primary" p="2x" width="100%">
      {children}
    </Box>
  );
};

export default MessageBubble;
